import { apiAction } from '../apiAction';

import { fetchAccountLineItemDetailTypes } from './types';
import * as api from './api';

export const fetchAccountLineItemDetail = apiAction({
  types: fetchAccountLineItemDetailTypes,
  apiAction: api.fetchAccountLineItemDetail,
});
